import { render, staticRenderFns } from "./TabOVHistoryActions.vue?vue&type=template&id=39640454&scoped=true&lang=pug"
import script from "./TabOVHistoryActions.vue?vue&type=script&lang=js"
export * from "./TabOVHistoryActions.vue?vue&type=script&lang=js"
import style0 from "./TabOVHistoryActions.vue?vue&type=style&index=0&id=39640454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39640454",
  null
  
)

export default component.exports